import React from 'react';
import { BaseStagePlugin, useActiveOriginIndex, useActiveStageIndex } from '@/framework';
import { IExportPlugin, PluginType } from '@/version-types';
import HelperView from './views/helper-view';
import './plugin.less';

/** 智能对齐 */
const SmartGuidesView: React.FC = React.memo(() => {
    const stageIndex = useActiveStageIndex();
    const activeOriginIndex = useActiveOriginIndex();

    return (
        <BaseStagePlugin name="smart-guides" originIndexOrLayerId={activeOriginIndex}>
            <HelperView index={stageIndex} />
        </BaseStagePlugin>
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 3,
    name: 'smart-guides',
    render() {
        return <SmartGuidesView />;
    },
};

export default exportPlugin;
